class CartPage extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        this.changeQty(qtyBtn.dataset.line, parseInt(qtyBtn.dataset.qtyChange, 10));
        return;
      }

      const removeBtn = e.target.closest('[data-remove-item]');
      if (removeBtn) {
        e.preventDefault();
        this.setLineQty(removeBtn.dataset.line, 0);
        return;
      }

      if (e.target.closest('[data-remove-coupon]')) {
        e.preventDefault();
        this.removeCoupon();
      }
    });
  }

  async changeQty(line, delta) {
    const display = this.querySelector(`[data-qty-display="${line}"]`);
    const current = display ? parseInt(display.textContent, 10) : 1;
    await this.setLineQty(line, Math.max(0, current + delta));
  }

  async removeCoupon() {
    if (this.loading) return;
    this.setLoading(true);
    try {
      const sectionId = this.closest('.shopify-section')?.id?.replace(/^shopify-section-/, '') || '';
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: '',
          sections: sectionId,
          sections_url: window.location.pathname,
        }),
      });
      await this.refresh();
      document.querySelector('cart-drawer')?.refresh?.();
    } finally {
      this.setLoading(false);
    }
  }

  async setLineQty(line, quantity) {
    if (this.loading) return;
    this.setLoading(true);

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity }),
      });

      await this.refresh();
      document.querySelector('cart-drawer')?.refresh?.();
    } finally {
      this.setLoading(false);
    }
  }

  async refresh() {
    const openTab = this.querySelector('cart-tabs')?.activeTab;
    const sectionId = this.closest('.shopify-section')?.id?.replace(/^shopify-section-/, '');
    if (!sectionId) return;

    const res = await fetch(`${window.location.pathname}?sections=${sectionId}&_=${Date.now()}`, {
      cache: 'no-store',
    });
    const data = await res.json();
    const html = data[sectionId];
    if (!html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newContent = doc.getElementById('cart-page-content');
    const current = this.querySelector('#cart-page-content');
    if (newContent && current) current.replaceWith(newContent);

    this.syncHeaderCount(doc.querySelector('cart-page')?.dataset.itemCount ?? '0');

    ['product', 'cart_total'].forEach((name) => {
      const input = document.querySelector(`.modal_cart-deposit [name="${name}"]`);
      const next = doc.querySelector(`.modal_cart-deposit [name="${name}"]`);
      if (input && next) input.value = next.value;
    });

    if (typeof runCurrencyConverter === 'function') {
      runCurrencyConverter();
    }

    if (openTab) this.querySelector('cart-tabs')?.showTab(openTab);
  }

  syncHeaderCount(count) {
    const badge = document.querySelector('[data-cart-count]');
    if (!badge) return;

    const n = parseInt(count, 10);
    badge.textContent = n > 0 ? n : '';
    badge.hidden = n === 0;
  }

  setLoading(state) {
    this.loading = state;
    this.toggleAttribute('data-loading', state);
  }
}

customElements.define('cart-page', CartPage);
